import styled from "styled-components";
import { OrganiserLoginFormStyle } from "@components/organiserLoginForm/organiserLoginFormStyle";

export const ParentLoginFormStyle = styled(OrganiserLoginFormStyle)`

`;
